
import { Loader } from "../../components/Loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { SearchContact } from "./SearchContact";
import { formatAddress } from "../../tools/utils";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { getOrganizationById } from "../../redux/thunks/organizationThunks";
import { useEffect } from "react";
import { setOrganization } from "../../redux/slices/organizationSlice";
import { useMediaQuery, useTheme } from "@mui/material";
import { NotificationBanner } from "../../components/NotificationBanner/NotificationBanner";
import { useGlobalContext } from "../../hooks/Helper/GlobalContext";

export const CCOAdvance = ({ headerMarginTop }: { headerMarginTop: number }) => {
  const { photoBannerVisible, PhotoBannerMessage } = useGlobalContext();
  const { organizationId } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const { organization, loading, error } = useSelector((state: RootState) => state.organization);

  useEffect(() => {
    if (organizationId) {
      dispatch(getOrganizationById(organizationId));
    }
  }, []);

  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>

      <div id="main-content" style={{ marginTop: headerMarginTop }}>
        <div className="cco_content_area cco_content_area_0">
          <article className="react-container">
            <NotificationBanner
              background="red"
              showBanner={photoBannerVisible}
              message={PhotoBannerMessage}
              color="white"
              type="photo"
            />
            <div className="cco_section cco_section_0">
              <div className="cco_row cco_row_8">

                <div className="cco_col">
                  <div className="cco_text cco_text_11">
                    <div className="cco_text_inner">
                      <strong>
                        <Link to={"/myCCOpro "}>{t('MyCCOPro.breadcrumb')}</Link>
                      </strong>
                      {"> "}
                      {loading ? "..." : organization?.OrgID}
                    </div>
                  </div>
                </div>


              </div>
              <>
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginBottom: "20px",
                    color: "#2d3748",
                    textAlign: "left",
                    marginTop: "30px",
                  }}
                >
                  {organization?.Name || ''}

                </h3>

                <li
                  className='cco_accordion_item'
                >
                  {(loading) ? (<Loader />) : error ? (<p>{error}</p>) : (
                    <div className="cco_accordion_item_header">
                      <div className="cco_text cco_text_3">

                        <div className="cco_text_inner">
                          <h3>
                            {organization?.Name || '[Company Name]'}
                            <span> - </span>
                            {formatAddress({
                              Zip: organization?.ZipCode,
                              City: organization?.City,
                              Type: 'Formatted',
                              Street1: organization?.Address1,
                              Street2: organization?.Address2,

                            })}
                          </h3>
                        </div>

                      </div>
                      <button
                        className="cco_accordion_item_toggle"
                        onClick={() => {
                          dispatch(setOrganization(organization));
                          navigate(`/OrganizationInformation/${organizationId}`);
                        }}
                      >
                        <span className="cco_accordion_item_toggle_text">     {t('MyCCOPro.DetailPage.edit')}</span>
                      </button>
                    </div>

                  )}
                </li>




                {/* Show SearchContact */}
                <div
                  className="cco_row cco_row_12"
                  style={{ marginTop: "10px" }}
                >

                  <h3
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      marginBottom: "20px",
                      color: "#2d3748",
                      textAlign: "left",
                      marginTop: "30px",
                    }}
                  >
                    CertConnect

                  </h3>
                   {!isMobile && (
                  <div className="cco_col cco_col_6">
                    <div className="cco_text cco_text_10">
                      <div className="cco_text_inner">
                        <p>
                          {t('MyCCOPro.DetailPage.certConnectDescriptionPart1')}
                          <a
                            href="https://www.nccco.org/PPA"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t('MyCCOPro.DetailPage.certConnectDescriptionLinkText')}
                          </a>
                          {t('MyCCOPro.DetailPage.certConnectDescriptionPart2')}
                          <p> {t('MyCCOPro.DetailPage.certConnectDescriptionPart3')} <a href="mailto:ccopro@ccocert.org">ccopro@ccocert.org</a> {t('MyCCOPro.DetailPage.certConnectDescriptionPart4')}</p>
                        </p>
                      </div>
                    </div>
                  </div>
                   )}
                </div>

                <div className="cco_col">
                  <div className="cco_text cco_text_10">
                    <div className="cco_text_inner">
                      <SearchContact />
                    </div>
                  </div>
                </div>

              </>

            </div>
          </article>
        </div>
      </div>

    </>
  );
};
